export default __webpack_public_path__ + "static/media/corporate-business.926d3e9b.png";